import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Redirect true desktop browsers to dumas.solutions.
// iPad Pro (iPadOS 13+) spoofs a Mac UA but has maxTouchPoints > 0,
// so we keep it here for the tablet layout.
function isTrueDesktop(): boolean {
  // Explicit mobile/tablet UA → never redirect
  if (/Mobile|Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile/i.test(navigator.userAgent)) {
    return false;
  }
  // Touch screen → tablet/hybrid device (e.g. iPad Pro with Macintosh UA) → keep
  if (navigator.maxTouchPoints > 0 || 'ontouchstart' in window) {
    return false;
  }
  // No touch + non-mobile UA → true desktop
  return true;
}

if (isTrueDesktop()) {
  window.location.replace('https://dumas.solutions');
} else {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
